import { RbacResourceAccess, UserPermissions } from '../../types/access'

const hasResourceAccess = (
  userPermissions: UserPermissions,
  requiredAccess: RbacResourceAccess,
): boolean => {
  const userResourceActions = userPermissions[requiredAccess.resource]
  if (!userResourceActions) return false

  const noActionsRequired =
    !requiredAccess.actions || requiredAccess.actions.length === 0
  if (noActionsRequired) return true

  return (requiredAccess.actions || []).every((requiredAction) =>
    userResourceActions.includes(requiredAction),
  )
}

export const hasPermission = (
  requiredAccess: RbacResourceAccess,
  userPermissions?: UserPermissions,
): boolean => {
  if (!userPermissions || Object.keys(userPermissions).length === 0)
    return false

  return hasResourceAccess(userPermissions, requiredAccess)
}

export const hasAllPermissions = (
  requiredPermissions: RbacResourceAccess[],
  userPermissions: UserPermissions,
): boolean => {
  if (!userPermissions || Object.keys(userPermissions).length === 0)
    return false

  return requiredPermissions.every((requiredAccess) =>
    hasPermission(requiredAccess, userPermissions),
  )
}

export const hasAnyPermissions = (
  requiredPermissions: RbacResourceAccess[],
  userPermissions: UserPermissions,
): boolean => {
  if (!userPermissions || Object.keys(userPermissions).length === 0)
    return false

  return requiredPermissions.some((requiredAccess) =>
    hasPermission(requiredAccess, userPermissions),
  )
}
